// extracted by mini-css-extract-plugin
export var pickerModal = "_id-0";
export var xButton = "_id-1";